const structCompiler = (data, struct = ["amount", "period", "reward", "startTime"]) => {
  const array = data.split(",");
  const structLen = struct.length;
  const length = array.length / structLen;
  return Array.from({ length }).reduce(
    (all, _, index) => [
      ...all,
      struct.reduce(
        (al, it, i) => {
          const item = i + structLen * index;
          return {
            ...al,
            [it]: Number(array[item]),
            endTime: it === "startTime" && Number(array[item]) + Number(al.period),
          };
        },
        { endTime: 0 }
      ),
    ],
    []
  );
};

export default structCompiler;
